import React, { useEffect, useState } from "react";
import { Box, Typography, Rating } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SportsIcon from "@mui/icons-material/Sports";
import { Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import {
  fetchcoachListData,
  fetchcoachSelectionData,
} from "../apiservices/ApiService";
import "../store/Fsn29CoachSelections.css";
import AppNavigation from "../navigation/AppNavigation";
import PrimaryButton from "../common/PrimaryButton";
import ParrotBorderButton from "../common/ParrotBorderButton";
import LoadingProgressBar from "../common/LoadingProgressBar";

const Fsn29CoachSelections = ({ onTap }) => {

  const navigate = useNavigate();

  const [coachList, setCoachList] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleBackButtonPress = () => {
    if (window.Android) {
      window.Android.onBackPressed();
    } else {
      navigate(-1);
    }
  };
  const { handleNavigation } = AppNavigation();

  const handleProfileClick = (coach) => {
    const onTap = {
      NavigationType: "3",
      FSN: "19", // Updated FSN value
      FSSN: "0",
      FAI: { ...coach }, // Include the full coach data
    };

    console.log("Updated onTap with full coach data:", onTap);

    handleNavigation(onTap); // Navigate with the updated onTap object
  };
  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  const handleCardSelect = (index) => {
    setSelectedCard(index === selectedCard ? null : index); // Toggle selection
  };

  const handleNextButtonClick = async () => {


    if (selectedCard === null) {
      alert("Please select a coach before proceeding.");
      return;
    }
    setLoading(true);
    const selectedCoach = coachList[selectedCard];
    console.log("Selected Coach:", selectedCoach);

    try {
      // Optional API call logic
      const response = await fetchcoachSelectionData({
        goqiiCoachId: selectedCoach.coachId,
        coachIntensity: "3",
      });

      console.log("API Response:", response);

      const onTap = {
        NavigationType: "3",
        FSN: "2", // Updated FSN value
        FSSN: "0",
        FAI: { coachId: selectedCoach.coachId, replace: true }, // Include the full coach data
      };

      console.log("Updated onTap with full coach data:", onTap);
      handleNavigation(onTap); // Navigate with the updated onTap object

      setLoading(false);
    } catch (error) {
      console.error("Error during API call:", error);
      alert("Failed to proceed. Please try again.");

      setLoading(false);
    }
  };

  useEffect(() => {
    const getCoachList = async () => {
      try {
        const response = await fetchcoachListData();
        if (Array.isArray(response)) {
          setCoachList(response); // Ensure response is an array
        } else {
          console.error("Invalid response format:", response);
          setCoachList([]);
        }
      } catch (error) {
        console.error("Error fetching coach list data:", error);
        setCoachList([]);
      } finally {
        setLoading(false);
      }
    };
    getCoachList();
  }, []);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <ArrowBackIosIcon
          sx={{ cursor: "pointer" }}
          onClick={handleBackButtonPress}
        />
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          {onTap?.FAI?.title || "Coach Selection"}
        </Typography>
      </Box>

      <div className="min-h-screen bg-gray-100 p-4">


        {loading ? (
          // <div className="text-center text-gray-500">Loading coaches...</div>

          <LoadingProgressBar />
        ) : (

          <>  <Box
            sx={{
              display: "flex", // Enables flexbox
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Centers vertically
              width: "200px", // Set the width of the Box
              height: "200px", // Set the height of the Box
              borderRadius: "50%", // Ensures a circular shape
              backgroundColor: "#f0f0f0", // Optional: Background color for visibility
              margin: "0 auto", // Ensures the Box itself is horizontally centered in its parent
            }}
          >
            <SportsIcon
              sx={{
                fontSize: 164, // Adjust the size of the icon
                color: "#1976d2", // Set the desired color
              }}
            />
          </Box>
            <div className="flex flex-col mb-2">
              <h2>Select Your Coaches</h2>
            </div>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="swiper-container"
            >
              {coachList.map((coach, index) => (
                <SwiperSlide key={index}>
                  <div
                    className={`coach-card ${selectedCard === index ? "selected" : ""
                      }`}
                    onClick={() => handleCardSelect(index)}
                  >
                    <div className="circle">
                      {selectedCard === index && <span className="tick">✔</span>}
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="coach-profile">
                        <img
                          src={coach.coachImage || "/api/placeholder/96/96"}
                          alt="Coach"
                          className=""
                        />
                      </div>
                    </div>
                    <div className="flex flex-col items-center">
                      <h2 className="text-xl font-semibold ">
                        {coach.coachName || "Internal"}
                      </h2>
                      <div className="text-sm text-gray-500 ">
                        {truncateText(
                          coach.professionalheadline || "Coach Type",
                          10
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Rating
                          value={coach.rating || 0}
                          precision={0.5}
                          readOnly
                        />
                        <span>{coach.rating || 0}</span>
                      </div>
                      <p className="text-center text-gray-700 line-clamp-2">
                        {truncateText(
                          coach.aboutMe ||
                          "Welcome to GOQii! I am your GOQii Coach.",
                          15
                        )}
                      </p>


                      <ParrotBorderButton onClick={() => handleProfileClick(coach)} label="View Profile" />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper></>
        )}
        {/* Log Button */}
        <PrimaryButton onClick={handleNextButtonClick} label="Select" />
      </div>
    </div>
  );
};

export default Fsn29CoachSelections;
